// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__2hoZ6","modal":"Modal_modal__1PLhA","slide-down":"Modal_slide-down__2DOh_"};